import React, { useEffect, useRef, useState } from 'react';
import { unstable_HistoryRouter as HistoryRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import HomePage from './pages/HomePage';
import SuperheroSelect from './pages/SuperheroSelect';
import PhotoCapture from './pages/PhotoCapture';
import PoseSelect from './pages/PoseSelect';
import GeneratePage from './pages/GeneratePage';
import Modal from './components/Modal';
import config from './config';
import './App.css';

const history = createBrowserHistory();

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathRef = useRef(location.pathname);
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [showBackModal, setShowBackModal] = useState(false);

  useEffect(() => {
    currentPathRef.current = location.pathname;
  }, [location.pathname]);

  // Track user activity
  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    const updateActivity = () => setLastActivity(Date.now());
    events.forEach(event => window.addEventListener(event, updateActivity));
    return () => events.forEach(event => window.removeEventListener(event, updateActivity));
  }, []);

  // Inactivity timer
  useEffect(() => {
    if (location.pathname === '/') return;
    const interval = setInterval(() => {
      if (Date.now() - lastActivity > 5 * 60 * 1000) {
        navigate('/', { replace: true });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [lastActivity, location.pathname, navigate]);

  // Disable right-click context menu for kiosk mode
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  // Removed global popstate handler to prevent duplicate navigation warnings
  // Individual pages now handle their own navigation warnings

  const handleBackConfirm = () => {
    setShowBackModal(false);
    navigate('/', { replace: true });
  };

  const handleBackCancel = () => {
    setShowBackModal(false);
  };

  // Debug kiosk mode
  console.log('Kiosk mode enabled:', config.kiosk);

  return (
    <div className={`App ${config.kiosk ? 'kiosk' : ''}`}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/select-superhero" element={<SuperheroSelect />} />
        <Route path="/capture-photo" element={<PhotoCapture />} />
        <Route path="/select-pose" element={<PoseSelect />} />
        <Route path="/generate" element={<GeneratePage />} />
      </Routes>

      <Modal
        isOpen={showBackModal}
        title="CONFIRM NAVIGATION"
        message="Are you sure you want to go back? This will take you to the home page."
        onConfirm={handleBackConfirm}
        onCancel={handleBackCancel}
        confirmText="GO TO HOME"
        cancelText="STAY HERE"
        showCancel={true}
      />
    </div>
  );
}

function AppWrapper() {
  return (
    <HistoryRouter history={history}>
      <App />
    </HistoryRouter>
  );
}

export default AppWrapper;
